// Pulls the keyset `cursor` token out of a pagination `_links` URL; undefined if absent.
export const cursorFromLink = (
  link: string | undefined
): string | undefined => {
  if (!link) return undefined

  const query = link.includes('?') ? link.slice(link.indexOf('?') + 1) : ''

  return new URLSearchParams(query).get('cursor') ?? undefined
}
